export const environment = {
  production: true,
  MAPQUEST_API_KEY: 'zZ2wiqALmCcDTvrdrshzP8T5SuASm9O0',
  deployed: true
};
